/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDatafusionMapError.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/datafusion-map-error";

export class AutogenModelDatafusionMapError<RowType extends ModelRow> extends Endpoint<RowType, RowDatafusionMapErrorFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDatafusionMapError extends ModelRow<RowDatafusionMapErrorFields> {
	constructor(values?: Partial<RowDatafusionMapErrorFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDatafusionMapErrorFields {
	company_id: string;
	direction: string;
	error_descr: string;
	error_type: string;
	id: string;
	parent_id: string;
	parent_tablename: string;
	transaction_type: string;
}

